import { render, staticRenderFns } from "./ProgramReports.vue?vue&type=template&id=e9882fa4&scoped=true&"
import script from "./ProgramReports.vue?vue&type=script&lang=ts&"
export * from "./ProgramReports.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramReports.vue?vue&type=style&index=0&id=e9882fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9882fa4",
  null
  
)

export default component.exports